import { render, staticRenderFns } from "./ModalRoleEdit.vue?vue&type=template&id=cb04dcb2&scoped=true"
import script from "./ModalRoleEdit.vue?vue&type=script&lang=js"
export * from "./ModalRoleEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalRoleEdit.vue?vue&type=style&index=0&id=cb04dcb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb04dcb2",
  null
  
)

export default component.exports